import { takeLatest, put, call, delay } from 'redux-saga/effects';
import * as type from '../../redux/types/trans';
import Api from '../../services/trans/trans';

let allApi = new Api();

async function fetchUser(data) {
    let res = await allApi.common(data);
    return res;

}

function* fetchData(action) {

    let payload = {
        "apiName": "getFolioList",
        "body": {}
    }
    let apiresponse = yield call(fetchUser, payload);

    if (apiresponse?.data?.success === true) {
        let allData = apiresponse?.data?.data;

        let HoldingMode = [];//modeofholding
        let DistFolio = [];// disting folio
        let holList = {}; // holding wise data object of array
        let folioList = {}//foliowiseData

        allData.map((curr, index) => {
            let getMoh = HoldingMode.indexOf(curr.accounttype);
            let getFolio = DistFolio.indexOf(curr.foliono);
            if (getMoh == -1) {
                HoldingMode.push(curr.accounttype)
            }
            if (getFolio == -1) {
                DistFolio.push(curr.foliono)
            }
        })



        HoldingMode.forEach((ele, index) => {
            let getName = [];
            allData.map((curr, indexC) => {
                if (curr.holdingMode === ele) {
                    getName.push(curr);
                }
            })
            holList[ele] = getName
        })

        DistFolio.forEach((ele, index) => {
            let getName = [];
            allData.map((curr, indexC) => {
                if (curr.foliono === ele) {
                    getName.push(curr);
                }
            })
            folioList[ele] = getName
        })
        let holdingFolio = {};
        let holdingName = {};
        HoldingMode.forEach((ele) => {
            let data = []
            let holderNameArray = [];
            let getData = holList[ele];
            if (getData !== undefined) {
                getData.map((curr, index) => {

                    if (curr.holdingMode === ele) {
                        let getFolio = data.indexOf(curr.foliono);
                        if (getFolio == -1) {
                            data.push(curr.foliono)
                        }


                        if (ele === "SINGLE") {
                            let getholderName = holderNameArray.indexOf(curr.holderName);
                            if (getholderName == -1) {
                                holderNameArray.push(curr.holderName)
                            }

                        }
                        if (ele === "MINOR") {
                            let getholderName = holderNameArray.indexOf(curr.guardianName);
                            if (getholderName == -1) {
                                holderNameArray.push(curr.guardianName)
                            }

                        }
                        if (ele === "JOINTLY") {
                            let getholderName = holderNameArray.indexOf(curr?.jointHolderName);
                            if (getholderName == -1) {
                                holderNameArray.push(curr?.jointHolderName)
                            }
                        }
                        if (ele === "ANYONE OR SURVIVOR") {
                            let getholderName = holderNameArray.indexOf(curr.jointHolderName);
                            if (getholderName == -1) {
                                holderNameArray.push(curr.jointHolderName)
                            }


                        }


                    }

                })
                holdingFolio[ele] = data
                holdingName[ele] = holderNameArray;
            }


        })

        let dataSet = {
            holdingFolio: holdingFolio,
            holdingName: holdingName,
            mohData: HoldingMode,
            mohWiseData: holList,
            folioData: DistFolio,
            folioWiseData: folioList,
            allData: allData
        }
        yield put({ type: type.FOLIO_KARY_SUCCESS, payload: dataSet })
    } else {
        let dataSet = {
            holdingFolio: {},
            holdingName: {},
            mohData: [],
            mohWiseData: {},
            folioData: [],
            folioWiseData: {},
            allData: []
        }
        yield put({ type: type.FOLIO_KARY_FAILED, payload: dataSet })
    }


}

export function* getFolioKary() {
    yield takeLatest(type.FOLIO_KARY_PENDING, fetchData)
}